import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IUndoCollectionTriageClipRequest } from './undo-collection-triage-clip-request';
import type { IUndoCollectionTriageClipResponse } from './undo-collection-triage-clip-response';
import { undoCollectionTriageClipResponseSchema } from './undo-collection-triage-clip-response';

export async function undoCollectionTriageClipApi({
  collectionId,
  clipId,
}: IUndoCollectionTriageClipRequest): Promise<
  IValidatedResponse<IUndoCollectionTriageClipResponse>
> {
  return postRequest<IUndoCollectionTriageClipResponse>({
    path: `/sys/collections/${collectionId}/triage/clips/${clipId}/undo`,
    body: {},
    schema: undoCollectionTriageClipResponseSchema,
  });
}
